import { Box, Heading } from '@chakra-ui/react';
import React from 'react';

import { colors } from 'packages/common-frontend/colors';
import { HighlightBox } from 'packages/common-frontend/components/HighlightBox';
import { useCreditFacilityContext } from 'packages/credit-facility/hooks/CreditFacilityProvider';
import {
  chargeOffAndDelinquentOverviewChartConfig,
  collectionsAccountChartConfig,
  daysPastDueChartConfig,
} from 'packages/portfolio/ui/profitLoss/profitLossChartConfigs';
import { ProfitLossOverviewChartTemplate } from 'packages/portfolio/ui/profitLoss/ProfitLossOverviewChartTemplate';
import { ProfitLossVintageChartTemplate } from 'packages/portfolio/ui/profitLoss/ProfitLossVintageChartTemplate';
import { RepaymentsVintageChart } from 'packages/portfolio/ui/profitLoss/RepaymentsVintageChart';
import { PortfolioCoreBorrowingBaseChartTemplate } from 'packages/portfolio/ui/shared/PortfolioCoreBorrowingBaseChartTemplate';

export const BorrowerPerformanceContainer = () => {
  const { creditFacilityId } = useCreditFacilityContext();

  return (
    <Box height="100%">
      <ProfitLossOverviewChartTemplate
        creditFacilityId={creditFacilityId}
        chartTitle="Charge Off & Delinquent"
        chartConfig={chargeOffAndDelinquentOverviewChartConfig}
      />
      <ProfitLossOverviewChartTemplate
        creditFacilityId={creditFacilityId}
        chartTitle="Days Past Due"
        chartConfig={daysPastDueChartConfig}
      />
      <PortfolioCoreBorrowingBaseChartTemplate
        creditFacilityId={creditFacilityId}
        chartTitle="Collections Account"
        chartConfig={collectionsAccountChartConfig}
      />
      <Heading as="h3" fontSize="24px" mb="24px">
        By Vintage
      </Heading>
      <HighlightBox backgroundColor={colors.millet[50]}>
        <RepaymentsVintageChart creditFacilityId={creditFacilityId} />
        <ProfitLossVintageChartTemplate
          creditFacilityId={creditFacilityId}
          chartTitle="Charge Off By Vintage"
          field="chargedOffPercentageOfTotalExposure"
          fieldType="percentage"
          yAxisLabel="Percent of Total Exposure"
        />
        <ProfitLossVintageChartTemplate
          creditFacilityId={creditFacilityId}
          chartTitle="Delinquency By Vintage"
          field="delinquentPercentageOfTotalExposure"
          fieldType="percentage"
          yAxisLabel="Percent of Total Exposure"
        />
      </HighlightBox>
    </Box>
  );
};
